import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../api/axios";

const ServiceAreaContext = createContext();

export const ServiceAreaProvider = ({ children }) => {
  const [serviceAreas, setServiceAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const { data } = await axios.get("/api/public/service-areas");
        if (data.success) setServiceAreas(data.service_areas);
      } catch (err) {
        console.error("🔥 Error fetching service areas:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAreas();
  }, []);

  return (
    <ServiceAreaContext.Provider value={{ serviceAreas, loading }}>
      {children}
    </ServiceAreaContext.Provider>
  );
};

export const useServiceAreas = () => useContext(ServiceAreaContext);
